jQuery(document).ready(function ($) {

    // Configurator page.
    (function () {
        if (!document.body.classList.contains("page-template-template-configurator-fortop-new")) {
            return;
        }

        var configurator_fortop_container = $(".fortop-configurator");
        if (configurator_fortop_container.length < 1) {
            return;
        }

        var decor_el = configurator_fortop_container.find("#decor");
        decor_el.ddslick({
            width: 250,
            background: "",
        });

    })();

});

(function() {
    class ForTopConfigurator {
        /** @var {HTMLElement} */
        $configurator;

        /** @var {HTMLInputElement} */
        $roomLength;

        /** @var {HTMLInputElement} */
        $roomWidth;

        /** @var {HTMLInputElement} */
        $innerCorners;

        /** @var {HTMLInputElement} */
        $outerCorners;

        /** @var {HTMLInputElement} */
        $decor;

        /** @var {HTMLInputElement} */
        $leftEndCap;

        /** @var {HTMLInputElement} */
        $rightEndCap;

        /** @var {HTMLInputElement} */
        $clutch;

        /** @var {HTMLButtonElement} */
        $submitButton;

        /** @var {object} */
        productsData;


        constructor($configurator, productsData) {
            this.$configurator = $configurator;
            this.productsData  = productsData;
        }

        initialize() {
            this.$roomLength   = this.$configurator.querySelector('#room_length');
            this.$roomWidth    = this.$configurator.querySelector('#room_width');
            this.$innerCorners    = this.$configurator.querySelector('#inner_corners');
            this.$outerCorners    = this.$configurator.querySelector('#outer_corners');
            this.$decor    = this.$configurator.querySelector('#decor');
            this.$leftEndCap    = this.$configurator.querySelector('#left_end_cap');
            this.$rightEndCap    = this.$configurator.querySelector('#right_end_cap');
            this.$coverRailHeating    = this.$configurator.querySelector('#cover_rail_heating');
            this.$submitButton = this.$configurator.querySelector('#submit_button');

            this.$configurator.addEventListener('submit', this.onSubmit.bind(this));
        }

        onSubmit(event) {
            event.preventDefault();
            this.createProduct();
        }

        calculatePerimeter() {
            let $roomLength = parseFloat( this.$roomLength.value );
            let $roomWidth = parseFloat( this.$roomWidth.value );

            return ( $roomLength + $roomWidth ) * 2;
        }

        calculateProducts() {
            let perimeter = this.calculatePerimeter();
            let $neededProducts = {};
            let requestedProducts = productsData[this.$decor.value];

            let neededClamps = perimeter / 0.5;
            let neededDowels = neededClamps * 2;

            if ( parseInt ( this.$coverRailHeating.value ) > 0 ) {
                neededClamps += 2 * parseInt ( this.$coverRailHeating.value );
                neededDowels += 4 * parseInt ( this.$coverRailHeating.value );
            }

            let dowelsPackage = requestedProducts['dowels']['package'];
            let neededDowelsPackages = Math.ceil( neededDowels / dowelsPackage );

            $neededProducts['cover_rail'] = { 'amount' : perimeter / 2 };
            $neededProducts['inner_corners'] = { 'amount' : parseInt( this.$innerCorners.value ) };
            $neededProducts['outer_corners'] = { 'amount' : parseInt ( this.$outerCorners.value ) };
            $neededProducts['left_end_cap'] = { 'amount' : parseInt ( this.$leftEndCap.value ) };
            $neededProducts['right_end_cap'] = { 'amount' : parseInt ( this.$rightEndCap.value ) };
            $neededProducts['clutch'] = { 'amount' : perimeter / 2 };
            $neededProducts['cover_rail_heating'] = { 'amount' : parseInt ( this.$coverRailHeating.value ) };
            $neededProducts['dowels'] = { 'amount' : neededDowelsPackages };
            $neededProducts['clamps'] = { 'amount' : neededClamps };

            return $neededProducts;
        }

        assignProducts() {
           let productsAmounts = this.calculateProducts();
           let requestedDekor  = productsData[this.$decor.value];

           const result = {
               cover_rail: {
                   amount: productsAmounts['cover_rail']['amount'],
                   product: requestedDekor['cover_rail']
               },
                inner_corners: {
                    amount: productsAmounts['inner_corners']['amount'],
                    product: requestedDekor['inner_corner']
                },
                outer_corners: {
                    amount: productsAmounts['outer_corners']['amount'],
                    product: requestedDekor['outer_corner']
                },
                left_end_cap: {
                    amount: productsAmounts['left_end_cap']['amount'],
                    product: requestedDekor['left_end_cap']
                },
                right_end_cap: {
                    amount: productsAmounts['right_end_cap']['amount'],
                    product: requestedDekor['right_end_cap']
                },
                clutch: {
                    amount: productsAmounts['clutch']['amount'],
                    product: requestedDekor['clutch']
                },
                cover_rail_heating: {
                    amount: productsAmounts['cover_rail_heating']['amount'],
                    product: requestedDekor['cover_rail_heating']
                },
                dowels: {
                    amount: productsAmounts['dowels']['amount'],
                    product: requestedDekor['dowels']
                },
                clamps: {
                    amount: productsAmounts['clamps']['amount'],
                    product: requestedDekor['clamps']
                }
           };

           return result;
        }

        createProduct() {
            let products = this.assignProducts();
            let $productsContainer = document.querySelector('#product-wrap');
            const $template = document.querySelector('#product-template');
            const $form = document.querySelector('#add_to_cart_form');
            const $input = $form?.querySelector('#product_cart');
            const toCartProducts = [];

            if ( $productsContainer.hasChildNodes() ) {
                $productsContainer.innerHTML = "";
            }

            for ( const product of Object.values(products) ) {

                if ( product['amount'] === 0 ) {
                    continue;
                }

                let $product = $template.content.cloneNode(true);
                let $productTitle = $product.querySelector('.product-title');
                let $productPrice = $product.querySelector('.product-price');
                let $productAmount = $product.querySelector('.product-amount');
                let $productImage = $product.querySelector('.product-image img');
                let $productLink = $product.querySelector('.product-link');

                $productTitle.textContent = product['product']['title'];
                $productAmount.textContent = product['amount'] + "x";
                $productImage.src = product['product']['image'];
                $productLink.href = product['product']['link'];

                if ( $productPrice ) {
                    $productPrice.textContent = Math.round((product['product']['price'] * product['amount']) * 100) / 100 + " Kč";
                }

                toCartProducts.push({
                    id: product['product']['id'],
                    amount: product['amount']
                });

                $productsContainer.appendChild($product);
            }

            if ( $form && $input ) {
                $input.value = JSON.stringify(toCartProducts);
                $form.classList.add('active');
            }
        }

    }

    // Initialize configurator.
    const $configurator = document.querySelector('.fortop-form');

    let productsData = $configurator.getAttribute("data-products");
    productsData = JSON.parse(productsData);

    $configurator.conf = new ForTopConfigurator($configurator);
    $configurator.conf.initialize();
})();
